import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';

import { ISlimScrollOptions } from 'ng2-slimscroll';
import { MemberService } from './../member.service';
import { MessageEvent, SignInEvent, OpenFrameEvent, LoaderEvent, HiddenFooter } from './../../shared/message.event';
import { AppService } from '../../app.service';
import { CONSTANT_VALUES } from '../../constants/constant-values';
import { Member } from './../member';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { UtilityFunctions } from '../../shared/utility-functions';

@Component({
  selector: 'app-member-detail',
  templateUrl: './member-detail.component.html',
  styleUrls: ['./member-detail.component.css'],
  providers: [MemberService, MessageEvent, SignInEvent, OpenFrameEvent, LoaderEvent, HiddenFooter]
})
export class MemberDetailComponent implements OnInit {
  private stringConstants = CONSTANT_MESSAGES;
  private _router;
  private shouldSlide: boolean = false;
  private popUpMessage: string;
  private popUpTitle: string;
  private validate;
  private vendor;
  private windowHeight = window.innerHeight;
  private topNav = 56;
  private midNav = 45;
  private footer = 35;
  private container = 50;
  private height: any;
  private divHeight = 30;
  private pagebutton = 10;
  private memberViewDetail: Member;
  private viewDetail = true;
  private previousMemberObj: any;
  private scrollOptions: ISlimScrollOptions;
  private facilityList = [];
  private disableMemberObj;
  private isDeactivateButton: boolean = false;
  private clubName: string;
  private joinDate: any;
  private isJoinDate: boolean = false;
  private errorMessage: string;
  private utilityFunctions = new UtilityFunctions();
  private contactWithCountryCode = '';
  private groups = [];
  private memberType = CONSTANT_VALUES.MEMBER_TYPE;
  private groupNames = '';
  private type = '';
  private staffActivities = [];
  private updateActivities = [];
  private staff;
  constructor(private router: Router, private memberService: MemberService, private appService: AppService,
    private openFrameEvent: OpenFrameEvent, private messageEvent: MessageEvent, private hiddenFooter: HiddenFooter,
    private signInEvent: SignInEvent, private loaderEvent: LoaderEvent) {
    this._router = router;
    this.popUpMessage = '';
    this.memberViewDetail = {
      'userId': '',
      'vendorId': '',
      'emailId': '',
      'contactNumber': '',
      'membershipId': '',
      'firstName': '',
      'lastName': '',
      'addressLine1': '',
      'addressLine2': '',
      'countryCode': '',
      'type': ''
    };
    this.validate = {
      'emailId': '',
      'contactNumber': '',
      'membershipId': '',
      'firstName': '',
      'lastName': '',
      'flag': false,
      'type': ''
    };
    this.disableMemberObj = {
      'userIds': [],
      'facilityId': '',
      'facilityName': '',
      'vendorId': '',
      'startTime': '',
      'endTime': '',
      'reason': '',
      'clubName': ''
    };
    this.scrollOptions = {
      barBackground: "#343a40", barOpacity: "0.6", position: "right",
      barWidth: "6", barBorderRadius: "5", barMargin: "1px 1px", gridBackground: "#adb5bd", gridOpacity: "1", gridWidth: "4", gridBorderRadius: "10", gridMargin: "1px 2px"
    };
    this.errorMessage = '';
    this.height = (this.windowHeight - (this.topNav + this.midNav + this.container + this.footer + this.divHeight + this.pagebutton)) + 'px';
    this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
    this.clubName = this.vendor.clubName;
  }

  ngOnInit() {
    if (localStorage.getItem('memberContactNumber')) {
      this.showDetail();
      this.appService.getFacilityList(this.vendor._id).then((result: any) => {
        if (result.status === CONSTANT_VALUES.RESPONSE_SUCCESS) {
          this.facilityList = result.facilityData;
        }
      }).catch((err) => {
        this.popUpMessage = err;
        this.loaderEvent.fire(true);
      });
      this.registerTypeBroadcast();
      this.emitOpenFrameEvent();
      this.emitTypeBroadcast();
    } else {
      this._router.navigate(['/member']);
    }

  }

  /**
   * while menu slide left to right as well as we shift header, footer and body too by broadcaster
   */
  registerTypeBroadcast() {
    this.messageEvent.on()
      .subscribe(message => {
        this.shouldSlide = message;
      });
  }
  /**
   * Show specific member details
   */
  showDetail() {
    this.loaderEvent.fire(false);
    let memberUserId = JSON.parse(atob(localStorage.getItem('memberUserId')));
      if(JSON.parse(atob(localStorage.getItem('memberRole'))) === 'staff'){
      let staffDetail = {
        vendorId: memberUserId,
        userId: this.vendor._id
      };
      this.appService.getStaffDetails(staffDetail).then((result: any) => {
        console.log('result');

        /*i
        addedOn:""
        addressLine1:""
        addressLine2:""
        contactNumber:"9739990080"
        countryCode:"+65"
        deactivatedOn:""
        deactivatedUntil:""
        disabledFacilities:[]
        emailId:""
        firstName:"Jeetendra"
        groupActivity:[]
        groups:["Abhi Group"]
        isActive:true
        isAdded:false
        isBlackListed:false
        isInviteSent:true
        lastName:"Choudhary"
        membershipId:"9739990080"
        note:""
        postalCode:""
        preferences:[]
        signedUpOn:""
        type:""
        uniqueCode:"8P2ZBK"
        userId:"5a364f34fe969c39d7587747"
        */
        if (result.status === CONSTANT_VALUES.RESPONSE_SUCCESS) {
          this.staff = result.vendor[0]
          let userDetailsObject = {
            addedOn: this.staff.createdAt,
            contactNumber: this.staff.contactNumber,
            countryCode: this.staff.countryCode,
            emailId: this.staff.emailId,
            firstName: this.staff.firstName,
            lastName: this.staff.lastName,
            membershipId: "NA",
            type: "Staff",
            userId: this.staff._id
          }
          this.staffActivities += this.staff.activities.map(activity => {
            return activity.activityName + ' '
          });
          this.memberViewDetail = userDetailsObject;
          this.memberViewDetail.userId = userDetailsObject.userId;
          // this.groupNames = this.memberViewDetail.groups.join();
          this.contactWithCountryCode = userDetailsObject.countryCode + ' ' + userDetailsObject.contactNumber;
          // this.isDeactivateButton = result.userDetails.isBlackListed;
          // this.previousMemberObj = JSON.parse(JSON.stringify(result.userDetails));
          this.joinDate = moment(userDetailsObject.addedOn).format('DD/MM/YYYY');
          this.isJoinDate = this.joinDate === 'Invalid date';
        } else {
          this._router.navigate(['/member']);
        }
        this.loaderEvent.fire(true);
      }).catch((err) => {
        this.loaderEvent.fire(true);
      });
    } else {
      let memberDetail = {
        vendorId: this.vendor._id,
        userId: memberUserId
      };
      this.appService.getMemberDetail(memberDetail).then((result: any) => {
        if (result.status === CONSTANT_VALUES.RESPONSE_SUCCESS) {
          this.memberViewDetail = result.userDetails;
          this.memberViewDetail.userId = memberUserId;
          this.groupNames = this.memberViewDetail.groups.join();
          this.contactWithCountryCode = this.memberViewDetail.countryCode + ' ' + this.memberViewDetail.contactNumber;
          this.isDeactivateButton = result.userDetails.isBlackListed;
          this.previousMemberObj = JSON.parse(JSON.stringify(result.userDetails));
          this.joinDate = moment(this.memberViewDetail['signedUpOn']).format('DD/MM/YYYY');
          this.isJoinDate = this.joinDate === 'Invalid date';
        } else {
          this._router.navigate(['/member']);
        }
        this.loaderEvent.fire(true);
      }).catch((err) => {
        this.loaderEvent.fire(true);
      });
    }
  }
  /**
   * Get member details
   *
   *
   * @memberof MemberDetailComponent
   */
  fetchMemberDetails() {
    this.memberViewDetail = this.appService.showMemberDetail();
    if (this.memberViewDetail) {
      this.isDeactivateButton = this.memberViewDetail['isBlackListed'];
      this.previousMemberObj = JSON.parse(JSON.stringify(this.memberViewDetail));
      this.joinDate = this.memberViewDetail['signedUpOn'];
      this.isJoinDate = this.joinDate === 'Invalid date';
    } else {
      this._router.navigate(['/member']);
    }
  }
  emitTypeBroadcast() {
    let isShow = {
      privacypolicy: true,
      support: false,
      footer: 'block'
    };
    this.signInEvent.fire('block');
    this.hiddenFooter.fire(isShow);
  }

  emitOpenFrameEvent() {
    this.openFrameEvent.fire(false);
  }

  /**
   * Go to home screen
   */
  homeScreen() {
    this.utilityFunctions.homeScreen(this);
  }

  /**
   * Make details editable
   */
  changeMode() {
    this.viewDetail = false;
  }
  /**
   * Show popup for delete member
   */
  makeDelete(userId, popUpObj) {
    this.popUpMessage = CONSTANT_MESSAGES.DELETE_MEMBER;
    popUpObj.showChildModal();
  }
  /**
   * Soft member details
   */
  confirmDelete(event, userId) {
    if (event) {
      if (this.memberViewDetail.type !== 'Staff') {
        let obj = {
          vendorId: this.vendor._id,
          userId: userId,
          emailId: this.memberViewDetail.emailId,
          contactNumber: this.memberViewDetail.contactNumber,
          countryCode: this.memberViewDetail.countryCode
        };
        this.memberService.deleteMember(obj).then((result: any) => {
          if (result.status === CONSTANT_VALUES.RESPONSE_SUCCESS) {
            this._router.navigate(['/']);
          } else {
          }
        });
      } else {
        let staff = {
          staffs: {
            "_id": this.memberViewDetail.userId,
            "firstName": this.memberViewDetail.firstName.trim(),
            "lastName": this.memberViewDetail.lastName.trim(),
            "emailId": this.memberViewDetail.emailId.trim(),
            "contactNumber": this.memberViewDetail.contactNumber,
            "countryCode": this.memberViewDetail.countryCode,
            "updatedBy": this.vendor._id,
            "createdBy": this.vendor._id,
            "vendorId": this.vendor._id,
            "activities": this.updateActivities,
            "isActive": false
          }
        }

        this.memberService.updateStaff(staff).then((result: any) => {
          if (result.status === CONSTANT_VALUES.RESPONSE_SUCCESS) {
            // console.log(result);
            this._router.navigate(['/']);
          } else {
            // this.errorMessage = result.message;
            // messagePopUp.showChildModal();
          }
        })
      }
    }
  }
  /**
   * Show popup to resend unique code to members email id
   */
  resendMail(popUpObj) {
    this.popUpMessage = CONSTANT_MESSAGES.RESEND_CODE_MEMBER;
    popUpObj.showChildModal();
  }

  /**
   * Resend unique code to members email id
   */
  confirmResendMail(event, obj: any, popUpObj) {
    if (this.staff) {
      let staffObj = {
        staffs: this.staff
      }
      this.memberService.resendInvite(staffObj).then((result: any) => {
        if (result.status === CONSTANT_VALUES.RESPONSE_SUCCESS) {
        } else {
        }
        this.popUpMessage = result.message;
        popUpObj.showChildModal();
      });
    } else {
      let memberObj = {
        emailId: obj.emailId,
        contactNumber: obj.contactNumber,
        countryCode: obj.countryCode,
        membershipId: obj.membershipId,
        firstName: obj.firstName,
        lastName: obj.lastName,
        type: obj.type,
        uniqueCode: obj.uniqueCode,
        userId: obj.userId
      };
      if (event && obj) {
        let obj = {
          vendorId: this.vendor._id,
          members: [memberObj],
          isWaitForCallback: false,
          clubName: this.vendor.clubName,
          isSendSMS: true
        };
        this.memberService.resendMail(obj).then((result: any) => {
          if (result.status === CONSTANT_VALUES.RESPONSE_SUCCESS) {
          } else {
          }
          this.popUpMessage = result.message;
          popUpObj.showChildModal();
        });


        // resendInvite
      }
    }
  }

  /**
   * Show popup to deactivate member
   */
  makeDisable(userId, popUpObj) {
    this.popUpMessage = CONSTANT_MESSAGES.DEACTIVATE_MEMBER;
    this.popUpTitle = 'Deactivate Member';
    popUpObj.showChildModal(this.popUpTitle, this.popUpMessage);
  }
  /**
   * Make deactivate member
   */
  confirmDeactivate(event, userId, popUpObj) {
    if (event) {
      let startDate: Date = event.startDate.setHours(0, 0, 0, 0);
      let endDate;
      if (event.endDate) {
        endDate = event.endDate ? event.endDate.setHours(24, 0, 0, 0) : null;
        endDate = new Date(endDate).toISOString();
      }
      let obj = {
        vendorId: this.vendor._id,
        userIds: userId ? [userId] : [],
        startTime: this.utilityFunctions.maketimeZoneOfsetDate(startDate, true),
        endTime: endDate ? this.utilityFunctions.maketimeZoneOfsetDate(endDate, true) : null,
        reason: event.reason
      };
      this.memberService.markDeactiveToMember(obj).then((result: any) => {
        if (result.status === CONSTANT_VALUES.RESPONSE_SUCCESS) {
          this._router.navigate(['/']);
        } else {
          this.popUpMessage = result.message;
          popUpObj.showChildModal();
        }
      });
    }
  }
  /**
   * Show popup to activate member
   */
  makeActivate(userId, popUpObj) {
    this.popUpMessage = CONSTANT_MESSAGES.ACTIVATE_MEMBER;
    popUpObj.showChildModal();
  }

  /**
   * Make activate member
   */
  confirmActivate(event, userId, popUpObj) {
    if (event) {
      let obj = {
        vendorId: this.vendor._id,
        userIds: [userId]
      };
      this.memberService.markActiveToMember(obj).then((result: any) => {
        if (result.status === CONSTANT_VALUES.RESPONSE_SUCCESS) {
          this._router.navigate(['/']);
        } else {
          this.popUpMessage = result.message;
          popUpObj.showChildModal();
        }
      });
    }
  }
  /**
      * Validate all member details fields while update
      */
  validationForMandatoryFields(validatePara) {
    try {
      let validateFlag = true;
      switch (validatePara) {
        case 'membershipId':
          if (!this.memberViewDetail.membershipId) {
            this.validate.membershipId = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
          } else {
            this.validate.membershipId = '';
          }
          break;
        case 'emailId':
          if (!this.memberViewDetail.emailId) {
            this.validate.emailId = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
          } else {
            this.validate.emailId = '';
          }
          break;
        case 'contactNumber':
          if (!this.memberViewDetail.contactNumber) {
            this.validate.contactNumber = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
          } else {
            this.validate.contactNumber = '';
          }
          break;
        case 'firstName':
          if (!this.memberViewDetail.firstName) {
            this.validate.firstName = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
          } else {
            this.validate.firstName = '';
          }
          break;
        /*case 'lastName':
            if (!this.memberViewDetail.lastName) {
                this.validate.lastName = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            } else {
                this.validate.lastName = '';
            }
            break;*/
        case '':
          validateFlag = this.validateMandatoryFields();
          break;
        case 'type':
          validateFlag = this.validateMandatoryFields();
          break;

      }
      return validateFlag;
    } catch (e) {
      console.log(e);
    }
  }
  /**
   * Validate all member detail fields
   *
   * @returns
   *
   * @memberof MemberDetailComponent
   */
  validateMandatoryFields() {
    this.validate.flag = true;
    if (!(this.memberViewDetail.membershipId + '').trim()) {
      this.validate.membershipId = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
      this.validate.flag = false;
    } else {
      this.validate.membershipId = '';
    }
    if (this.memberViewDetail.emailId) {
      if (!this.utilityFunctions.validateEmail(this.memberViewDetail.emailId)) {
        this.validate.emailId = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        this.validate.flag = false;
      } else {
        this.validate.emailId = '';
      }
    }
    if (!(this.memberViewDetail.contactNumber + '').trim()) {
      this.validate.contactNumber = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
      this.validate.flag = false;
    } else {
      this.validate.contactNumber = '';
    }
    if (!(this.memberViewDetail.firstName + '').trim()) {
      this.validate.firstName = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
      this.validate.flag = false;
    } else {
      this.validate.firstName = '';
    }
    /*if (!(this.memberViewDetail.lastName + '').trim()) {
        this.validate.lastName = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        this.validate.flag = false;
    } else {
        this.validate.lastName = '';
    }*/
    return this.validate.flag;
  }
  /**
  * Update member details
  */
  updateMember(messagePopUp) {
    if (this.validateMandatoryFields()) {
      if (this.memberViewDetail.type == 'Staff') {
        let staff = {
          staffs: {
            "_id": this.memberViewDetail.userId,
            "firstName": this.memberViewDetail.firstName.trim(),
            "lastName": this.memberViewDetail.lastName.trim(),
            "emailId": this.memberViewDetail.emailId.trim(),
            "contactNumber": this.memberViewDetail.contactNumber,
            "countryCode": this.memberViewDetail.countryCode,
            "updatedBy": this.vendor._id,
            "createdBy": this.vendor._id,
            "vendorId": this.vendor._id,
            "activities": this.updateActivities
          }
        }

        this.memberService.updateStaff(staff).then((result: any) => {
          if (result.status === CONSTANT_VALUES.RESPONSE_SUCCESS) {
            // console.log(result);
            this._router.navigate(['/']);
          } else {
            this.errorMessage = result.message;
            messagePopUp.showChildModal();
          }
        })
      } else {
        let member = {
          vendorId: this.vendor._id,
          userId: this.memberViewDetail.userId,
          changes: {
            membershipId: this.memberViewDetail.membershipId.trim(),
            emailId: this.memberViewDetail.emailId.trim(),
            firstName: this.memberViewDetail.firstName.trim(),
            lastName: this.memberViewDetail.lastName.trim(),
            contactNumber: this.memberViewDetail.contactNumber,
            countryCode: this.memberViewDetail.countryCode,
            addressLine1: this.memberViewDetail.addressLine1,
            addressLine2: this.memberViewDetail.addressLine2,
            type: this.type ? this.type : this.memberViewDetail.type
          }
        };
        this.memberService.updateMember(member).then((result: any) => {
          if (result.status === CONSTANT_VALUES.RESPONSE_SUCCESS) {
            this._router.navigate(['/']);
          } else {
            this.errorMessage = result.message;
            messagePopUp.showChildModal();
          }
        });
      }
    }
  }
  /**
   * Disable member
   */
  disableMember(disableObj: any, popUpObj: any) {
    this.disableMemberObj.facilityName = disableObj.facility.name;
    // this.disableMemberObj.duration = disableObj.days * 24;
    this.disableMemberObj.facilityId = disableObj.facility._id;
    this.disableMemberObj.vendorId = this.vendor._id;
    this.disableMemberObj.userIds = this.memberViewDetail.userId ? [this.memberViewDetail.userId] : [];
    this.disableMemberObj.startTime = this.utilityFunctions.maketimeZoneOfsetDate(disableObj.startTime, true);
    this.disableMemberObj.endTime = this.utilityFunctions.maketimeZoneOfsetDate(disableObj.endTime, true);
    this.disableMemberObj.reason = disableObj.reason;
    this.disableMemberObj.clubName = this.vendor.clubName;
    this.loaderEvent.fire(false);
    this.memberService.disableMemberForSpecificFacility(this.disableMemberObj).then((result: any) => {
      if (result.status === CONSTANT_VALUES.RESPONSE_SUCCESS) {
        this.popUpMessage = result.message;
      } else {
        this.popUpMessage = result.message;
      }
      popUpObj.showChildModal();
      this.loaderEvent.fire(true);
    }).catch((err) => {
      this.popUpMessage = err;
      this.loaderEvent.fire(true);
    });
  }

  linkActivities(linkActivityPopup) {
    linkActivityPopup.showChildModal(this.staff);
  }

  editGroup(this, $event) {
    this.staffActivities = $event.staff.activities.map(activity => {
      return activity.activityName + ' '
    });
    this.updateActivities = $event.staff.activities;
  }
}



// WEBPACK FOOTER //
// ./src/app/member/member-detail/member-detail.component.ts